import type { FAQ_Dto, FAQ_ListDTO } from "@hitit/api";

type SortedIndexFAQ_LIST_DTO = FAQ_ListDTO & { originDisplaysort: number }

export class FAQ_Manager {
    static readonly __All__ = "전체"
    static readonly tempREG = /^\|TEMP\|/;
    static readonly newREG = /^\|NEW\|/;

    // public all: FAQ_Category
    public categories: FAQ_Category[]
    public deletedItems: FAQ[] = []

    constructor(faqListDTOs: FAQ_ListDTO[]) {
        const sortedFAQListDtos: SortedIndexFAQ_LIST_DTO[] = faqListDTOs.sort((a, b) => a.displaySort - b.displaySort).map((v, i) => {
            return Object.assign({}, v, { originDisplaysort: v.displaySort, displaySort: i })
        });
        const categoriesNames = new Set(sortedFAQListDtos.map((v) => v.category));
        const sorted = [...categoriesNames].sort((a, b) => a < b ? -1 : 1)
        const mappingDTOs = sorted.map((v) => {
            const dtos = sortedFAQListDtos.filter((dto) => dto.category === v);
            const sorted = dtos.sort((a, b) => a.displaySort - b.displaySort);
            return {
                categoryName: v,
                dtos: sorted
            }
        })


        this.categories = mappingDTOs.map((v) => new FAQ_Category(v.categoryName, v.dtos))

    }

    getCategories() {
        return [this.getAll(), ...this.categories];
    }

    getAll() {
        const faqs = this.categories
            .reduce((prev, cur) => {
                return [...prev, ...cur.faqs]
            }, [] as FAQ[])
            .sort((a, b) => a.displaySort - b.displaySort)

        const all = new FAQ_Category(FAQ_Manager.__All__, [], false);
        all.faqs = faqs;
        return all

    }

    updateDisplaySort(from: FAQ, to: FAQ) {
        const all = this.getAll();

        const start = Math.min(from.displaySort, to.displaySort);
        const end = Math.max(from.displaySort, to.displaySort)
        const moveToBehinde = start === from.displaySort
        const filterCallback = moveToBehinde
            ? ({ displaySort }: { displaySort: number }) => start < displaySort && end >= displaySort
            : ({ displaySort }: { displaySort: number }) => start <= displaySort && end > displaySort
        const betweens = all.faqs.filter(filterCallback);

        for (const faq of betweens) {
            faq.displaySort = faq.displaySort + (moveToBehinde ? -1 : 1)
        }
        from.displaySort = to.displaySort + (moveToBehinde ? 1 : -1);

        for (const categoryName of new Set([from, ...betweens].map((v) => v.category))) {
            const sortingTarget = this.categories.find((v) => v.name === categoryName);
            sortingTarget?.faqs.sort((a, b) => a.displaySort - b.displaySort)
        }

    }

    getNames() {
        return this.getCategories().filter((v) => v.status !== "DELETED").map((v) => v.name)
    }

    addCategory(name: string) {
        const category = new FAQ_Category(name, []);
        const sorted = [...this.categories, category].sort((a, b) => a.name < b.name ? -1 : 1)
        this.categories = sorted
        return category
    }

    resoting() {
        const sorted = [...this.categories].sort((a, b) => a.name < b.name ? -1 : 1)
        this.categories = sorted
        return sorted
    }

    getNewItemDisplaySort() {
        const filterd = this.getAll().faqs.filter((v) => v.status !== "DELETED");
        return filterd.reduce((prev, cur) => {
            if (prev < cur.displaySort) return cur.displaySort;
            return prev
        }, -1) + 1

    }

    deleteCategory(deleted: FAQ_Category) {
        const filtered = this.categories.filter((v) => v !== deleted);
        this.deletedItems = [...this.deletedItems, ...deleted.faqs];
        this.categories = filtered;
        return deleted
    }

    deleteQnA_ById(id: string) {
        const faqs = this.getAll().faqs
        const originCategoryName = faqs.find((v) => v.id === id)?.category;
        const findCategory = this.categories.find((v) => v.name === originCategoryName)

        if (findCategory) {
            const findOrigin = findCategory.faqs.find((v) => v.id === id)
            findCategory.faqs = findCategory.faqs.filter((v) => findOrigin !== v);
            findOrigin && this.deletedItems.push(findOrigin)
        }

    }


    addNewItem(faq: FAQ) {
        const category = this.categories.find((V) => V.name === faq.category) as FAQ_Category;
        faq.id = "|NEW|" + Math.random();
        category.faqs.push(faq);
        category.faqs = category.faqs.sort((a, b) => a.displaySort - b.displaySort)
    }

    updateItemArticle(faq: FAQ) {
        const faqId = faq.id || ""
        const originCategory = this.categories.find((v) => v.name === faq.category) as FAQ_Category
        const originFAQIndex = originCategory.faqs.findIndex((v) => v.id === faqId);
        if (originFAQIndex !== -1) {
            faq.changed = true
            originCategory.faqs[originFAQIndex] = faq
            console.log(originCategory)
        }
    }

    getDTO_ToSend() {
        const all = this.getAll().faqs;

        const newFaqCheck = (id: string) => FAQ_Manager.newREG.test(id);
        const newFaqs: FAQ_Dto[] = [];
        const onlyCategoryUpdatedFaqs: FAQ_Dto[] = [];
        const updatedFaqs: FAQ_Dto[] = [];
        const indexChangedFaqs: FAQ_Dto[] = [];
        const deletedFaqs: FAQ_Dto[] = this.deletedItems.filter((v) => FAQ_Manager.newREG.test(v.id || "") === false).map((v) => v.convertFAQ_DTO())

        for (const faq of all) {
            if (newFaqCheck(faq.id as string)) {
                newFaqs.push(faq.convertFAQ_DTO())
            } else if (faq.answer === undefined && faq.changed) {
                onlyCategoryUpdatedFaqs.push(faq.convertFAQ_DTO());
            } else if (faq.changed) {
                updatedFaqs.push(faq.convertFAQ_DTO())
            } else if (faq.displaySort !== faq.originDisplaysort) { //Only Index changed
                indexChangedFaqs.push(faq.convertFAQ_DTO())
            }
        }

        return {
            newFaqs,
            onlyCategoryUpdatedFaqs,
            updatedFaqs,
            indexChangedFaqs,
            deletedFaqs
        }
    }
}

export class FAQ_Category {

    public status: "EXIST" | "DELETED"
    public name: string
    public faqs: FAQ[]
    public editable = true
    constructor(name: string, faqListDTOs: SortedIndexFAQ_LIST_DTO[], editable = true) {
        this.status = "EXIST"
        this.name = name;
        this.faqs = faqListDTOs.map((v) => new FAQ(v, "EXIST"));
        this.editable = editable
    }

    delete() {
        this.status = "DELETED";
        for (const faq of this.faqs) {
            faq.status = "DELETED"
        }
    }

    getLength() {
        return this.faqs.length
    }

    updateName(newName: string) {
        this.name = newName;
        this.faqs.forEach((v) => {
            v.category = newName;
            v.changed = true
        })
        return newName
    }

    mappingItems() {
        return this.faqs.map((v) => ({
            title: v.question,
            displaySort: v.displaySort,
            id: v.id || '',
            question: v.question,
            documentState: v.documentState

        }))
    }

    getFAQ_ById(id: string) {
        return this.faqs.find((v) => v.id === id) || null
    }



}

export class FAQ {

    status: "NEW" | "EXIST" | "DELETED"
    changed: boolean = false
    id?: string;
    displaySort: number;
    viewCount?: number;
    createdDate?: string;
    documentState: string;
    question: string;
    answer?: string;
    category?: string;
    originDisplaysort: number;

    constructor(faqListDTO: SortedIndexFAQ_LIST_DTO, status: "NEW" | "EXIST") {
        const { id, displaySort, viewCount, createdDate, documentState, question, category, originDisplaysort } = faqListDTO
        this.status = status;
        this.id = id;
        this.displaySort = displaySort;
        this.viewCount = viewCount;
        this.createdDate = createdDate
        this.documentState = documentState;
        this.question = question
        this.category = category
        this.originDisplaysort = originDisplaysort
    }

    static convenienceConstructor(displaySort: number, documentState: string, category: string) {
        const dto: SortedIndexFAQ_LIST_DTO = {
            displaySort, documentState, category,
            id: `|TEMP|${Math.random()}`,
            question: "",
            viewCount: 0,
            createdDate: "",
            originDisplaysort: displaySort
        };

        return new FAQ(dto, "NEW")
    }

    convertFAQ_ListDTO_ForAll(): FAQ_ListDTO {
        return {
            id: this.id || "",
            displaySort: this.displaySort,
            viewCount: this.viewCount || 0,
            createdDate: this.createdDate || "",
            documentState: this.documentState,
            question: this.question,
            category: this.category || ""

        }
    }

    convertFAQ_DTO(): FAQ_Dto {
        const faqDTO: FAQ_Dto = {
            id: FAQ_Manager.newREG.test(this.id || "") ? undefined : this.id,
            displaySort: this.displaySort,
            documentState: this.documentState,
            question: this.question,
            answer: this.answer || "",
            category: this.category || ""
        }
        return faqDTO
    }

    getLink() {
        if (FAQ_Manager.newREG.test(this.id || "") || this.documentState !== "PUBLISHED") return undefined;

        const domain = "HITIT_HUBINFO_URL";
        const linkpath = `faq/?category=${encodeURI(this.category || "")}&id=${this.id || ""}`
        return domain + linkpath
    }
}